/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useContext } from "react";
import { ContentZoneContext } from "cms/components/context/index";
import { ImageLinkItem } from "./image-link-item";

const ImageLinkComponentDisplay = () => {

    const { component } = useContext(ContentZoneContext);
    const { image_list: imageList, sectionName } = component || {};

    const hasImageList = imageList && imageList.length > 0;

    return (
        <div className='image-link-component-display'>
            {sectionName && <h4>{sectionName}</h4>}
            {hasImageList &&
                <div className='image-link-items-container'>
                    {imageList.map((item, index) => (
                        <ImageLinkItem item={item} key={`image-link-item-${index}`} />
                    ))}
                </div>
            }
        </div>
    );
};

ImageLinkComponentDisplay.displayName = "ImageLinkComponentDisplay";
export { ImageLinkComponentDisplay };
